module.exports = __webpack_public_path__ + "static/proposal.b38d9554.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/proposal.png
// module id = 446
// module chunks = 168707334958949